import { Route } from 'vue-router'
import { Component } from 'vue-router/types/router'

export const numberFormat = (num: number): string => {
  return new Intl.NumberFormat().format(num)
}

/**
 * 相対パスからアプリケーション経由でDB、ストレージに保存された画像を出力する
 * @param path 画像の相対パス
 */
export const getImageUrl = (path: string): string => {
  return process.env.VUE_APP_DB_ASSET_HOST + '/' + path
}

/**
 * 相対パスからWEB用の画像URLを返す
 * @param path 画像の相対パス
 */
export const asset = (path: string): string => {
  return `/${path}`
}

/**
 * Twitterのツイートモーダルのようなページの重ね方で表示させるためのModal設定
 * @see https://github.com/tmiame/vue-router-twitter-style-modals
 */
export const setModalComponent = (to: Route, from: Route, modal: Component) => {
  if (from.matched.length === 0) {
    // For direct access
    // App.vue: matched[0], layouts/default.vue: matched[1]
    to.matched[1].components = {
      default: modal,
    }
  }

  if (from.matched.length > 0) {
    if (from.matched.length > 1) {
      // copy nested router
      const childrenView = from.matched.slice(1, from.matched.length)
      for (const view of childrenView) {
        to.matched.push(view)
      }
    }
    if (to.matched[1].components) {
      // Rewrite components for `default`
      to.matched[1].components.default = from.matched[1].components.default
      // Rewrite components for `modal`
      to.matched[1].components.modal = modal
    }
  }
}

export const handleIntended = (to: Route, from: Route): Route | void => {
  // 意図したURLになったらintendedはつけずに着地
  if (to.path === from.query.intended) {
    return
  }

  //意図したURLになるまでintendedを付与
  to.query.intended = from.query.intended
  return to
}
